import { render } from "./modalCertificado.vue?vue&type=template&id=08ff57e5"
import script from "./modalCertificado.vue?vue&type=script&lang=js"
export * from "./modalCertificado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__